// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audio-dialog .upload-controls {\n  padding: 35px 0 !important;\n}\n.audio-dialog .sound-editor-dialog .audio-player {\n  width: 100%;\n}\n.audio-dialog .sound-editor-dialog .title {\n  margin-top: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
